// $(document).ready(function() {
document.addEventListener("DOMContentLoaded", function() {
    let currentLetter = "A";

    let firstname;
    let lastname;
    let jobtitle;
    let phone;
    let departmentTitle;
    let departmentCode;

    let navigationContainer = document.getElementById("listOfLetters");
    let contentContainer = document.getElementById("listOfContacts");
    let contentContainerMobile = document.getElementById(
        "listOfMobileContacts"
    );
    let contactCounter = 1;
    let contactCounterMobile = 1;

    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    function insertContactList(person) {
        let contactElement = document.createElement("tr");
        contactElement.classList.add("singleContact");
        if (contactCounter % 2 == 0) {
            contactElement.classList.add("even");
        } else {
            contactElement.classList.add("odd");
        }

        let firstnameElement = document.createElement("td");
        firstnameElement.innerText = htmlDecode(person.firstname);

        let lastnameElement = document.createElement("td");
        lastnameElement.innerText = htmlDecode(person.lastname);

        let jobtitleElement = document.createElement("td");
        jobtitleElement.innerText = htmlDecode(person.jobtitle);

        let phoneElement = document.createElement("td");
        let phoneLinkElement = document.createElement("a");
        phoneLinkElement.setAttribute(
            "title",
            person.lastname +
                ", " +
                person.firstname +
                " - Tlf: " +
                person.phone
        );
        phoneLinkElement.setAttribute("href", "tel:" + parseInt(person.phone));
        phoneLinkElement.innerText = person.phone;
        phoneElement.appendChild(phoneLinkElement);

        let departmentTitleElement = document.createElement("td");
        departmentTitleElement.innerText = htmlDecode(person.departmentTitle);

        contactElement.appendChild(lastnameElement);
        contactElement.appendChild(firstnameElement);
        contactElement.appendChild(jobtitleElement);
        contactElement.appendChild(departmentTitleElement);
        contactElement.appendChild(phoneElement);

        contentContainer.appendChild(contactElement);
        contactCounter++;
    }

    //Mobile view
    function insertMobileContactList(person) {
        let keys = [
            "Efternavn",
            "Fornavn",
            "Stilling",
            "Kontorbetegnelse",
            "Tlf"
        ];
        let values = [
            person.lastname,
            person.firstname,
            person.jobtitle,
            person.departmentTitle,
            person.phone
        ];
        let mobileItem = document.createElement("table");
        mobileItem.classList.add("mobileContactItem");
        let tbody = document.createElement("tbody");

        let trLastname = document.createElement("tr");
        let trFirstname = document.createElement("tr");
        let trJobTitle = document.createElement("tr");
        let trDepartment = document.createElement("tr");
        let trPhone = document.createElement("tr");

        let personItems = [];
        personItems.push(trLastname);
        personItems.push(trFirstname);
        personItems.push(trJobTitle);
        personItems.push(trDepartment);
        personItems.push(trPhone);

        personItems.forEach((item, i) => {
            if (contactCounterMobile % 2 == 0) {
                item.classList.add("even");
            } else {
                item.classList.add("odd");
            }

            let td1 = document.createElement("td");
            td1.classList.add("st-key");
            td1.innerText = keys[i];

            let td2 = document.createElement("td");
            td2.classList.add("st-value");
            if (i === 4) {
                let phoneLink = document.createElement("a");
                phoneLink.setAttribute(
                    "title",
                    person.lastname +
                        ", " +
                        person.firstname +
                        " - Tlf: " +
                        person.phone
                );
                phoneLink.setAttribute("href", "tel:" + parseInt(person.phone));
                phoneLink.innerText = values[i];
                td2.appendChild(phoneLink);
            } else {
                td2.innerText = htmlDecode(values[i]);
            }

            item.appendChild(td1);
            item.appendChild(td2);
            tbody.appendChild(item);
        });
        mobileItem.appendChild(tbody);
        contentContainerMobile.appendChild(mobileItem);
        contactCounterMobile++;
    }

    function getList(letter) {
        let sortedList;
        let filteredList;

        if (letter === "Aa") {
            filteredList = people.filter(
                person => person.lastname.substring(0, 2) === letter
            );
        } else if (letter === "A") {
            let refilteredList = people.filter(
                person => person.lastname.charAt(0).toUpperCase() === letter
            );
            filteredList = refilteredList.filter(
                person => person.lastname.charAt(1) !== "a"
            );
        } else if (letter === "Ø") {
            filteredList = people.filter( person => {
                const lastName = person.lastname.replace(/&#(\d+);/g, (_, dec) =>
                    String.fromCharCode(dec)
                );

                return lastName.startsWith(letter);
            });
        } else {
            filteredList = people.filter(
                person => person.lastname.charAt(0).toUpperCase() === letter
            );
        }        

        sortedList = filteredList.sort((a, b) => {
            const result = a.lastname.localeCompare(b.lastname);
            return result !== 0
                ? result
                : a.firstname.localeCompare(b.firstname);
        });
        contactCounter = 1;
        sortedList.forEach(person => insertContactList(person));
        contactCounterMobile = 1;
        sortedList.forEach(person => insertMobileContactList(person));
    }

    function setCurrentLetter(letter, el) {
        let activeEl = document.getElementsByClassName("active__navletter");
        activeEl[0].classList.remove("active__navletter");
        el.classList.add("active__navletter");
        currentLetter = letter;

        let desktopContacts = document.getElementsByClassName("singleContact");
        [...desktopContacts].forEach(x => {
            x.parentNode.removeChild(x);
        });
        let mobileContacts = document.getElementsByClassName(
            "mobileContactItem"
        );
        [...mobileContacts].forEach(x => {
            x.parentNode.removeChild(x);
        });

        getList(currentLetter);
    }

    let firstElement = true;
    function createNav() {
        let alphabet = "abcdefghijklmnopqrstuvwxyzæøå";
        let thisLetter;
        for (let i = 0; i < alphabet.length; i++) {
            if (i === 28) {
                thisLetter = "Aa";
            } else {
                thisLetter = alphabet.charAt(i).toUpperCase();
            }
            let navItem = document.createElement("a");
            navItem.setAttribute("href", "javascript:;");
            navItem.setAttribute(
                "aria-label",
                "see all lastnames starting with " + thisLetter
            );
            if (firstElement) {
                navItem.classList.add(
                    "phonebook__nav__nav-item",
                    "active__navletter"
                );
                firstElement = false;
            } else {
                navItem.classList.add("phonebook__nav__nav-item");
            }

            navItem.innerText = thisLetter;
            navItem.addEventListener("click", function(el) {
                if (el.originalTarget !== undefined) {
                    setCurrentLetter(el.originalTarget.innerText, navItem);
                } else if (el.target !== undefined) {
                    setCurrentLetter(el.target.innerText, navItem);
                }
            });
            navigationContainer.appendChild(navItem);
        }
    }

    if (navigationContainer != null) {
        createNav();
        getList(currentLetter);
    }
    
});
